<template>
  <div class="home">
    <my-swiper :bannerList="bannerList"></my-swiper>
    <div class="home-evaluate">
      <div class="home-title">驾培行业服务综合评价</div>
      <div class="evaluate" v-if="homeEvaluate">
        <div class="eva-total">
          <p class="total-title">评价总数</p>
          <div class="total-info">
            <p class="info-num">{{homeEvaluate.total}}</p>
            <p class="info-name">条</p>
          </div>
        </div>
        <div class="eva-total eva-center">
          <p class="total-title">收到差评数</p>
          <div class="total-info">
            <p class="info-num">{{homeEvaluate.badTotal}}</p>
            <p class="info-name">条</p>
          </div>
        </div>
        <div class="eva-total eva-center">
          <p class="total-title">差评整改率</p>
          <div class="total-info">
            <p class="info-num">{{homeEvaluate.badRate}}</p>
            <p class="info-name">%</p>
          </div>
        </div>
        <div class="eva-average">
          <p class="total-title">平均分</p>
          <div class="total-info">
            <p class="info-num">{{homeEvaluate.avg}}</p>
            <p class="info-name">分</p>
            <el-rate class="info-rate" v-model="homeEvaluate.avg" disabled text-color="#ff9900" score-template="{score}"></el-rate>
          </div>
        </div>
      </div>
    </div>
    <div class="zlxc-container" style="overflow: visible">
      <div class="home-layout" v-if="censusListDate">
        <div class="home-title">
          <p class="title-main">驾培实时数据</p>
          <p class="title-sub">汇集杭州市所有驾校</p>
        </div>
        <div class="home-module">
          <div class="module-right">
            <div class="right-top">
              <p class="top-title">驾培实时数据</p>
              <ul class="top-list">
                <li class="list-li">
                  <p class="li-name">驾校</p>
                  <p class="li-num">{{censusListDate.schoolCount}}家</p>
                </li>
                <li class="list-li">
                  <p class="li-name">教练员</p>
                  <p class="li-num">{{censusListDate.coachCount}}人</p>
                </li>
                <li class="list-li">
                  <p class="li-name">教练车</p>
                  <p class="li-num">{{censusListDate.coachCarCount}}辆</p>
                </li>
              </ul>
            </div>
            <div class="right-bottom">
              <ul class="bottom-list">
                <li class="list-li">
                  <div class="li-img-cistern" :title="censusListDate.studentCount + '人'">
                    <img
                      class="li-img"
                      src="../../assets/zlxcimgs/home_image_xuejiaren@2x.png"
                    >
                    <p class="li-num">{{censusListDate.studentCount > 9999 ? (censusListDate.studentCount/10000).toFixed(2) + '万' : censusListDate.studentCount}}<span>人</span></p>
                  </div>
                  <p class="li-name">学驾人</p>
                </li>
                <li class="list-li">
                  <div class="li-img-cistern" :title="censusListDate.applyTodayCount + '人'">
                    <img
                      class="li-img"
                      src="../../assets/zlxcimgs/home_image_jinribaom@2x.png"
                    >
                    <p class="li-num">{{censusListDate.applyTodayCount}}<span>人</span></p>
                  </div>
                  <p class="li-name">今日报名</p>
                </li>
                <li class="list-li">
                  <div class="li-img-cistern" :title="censusListDate.trainTodayCount + '人'">
                    <img
                      class="li-img"
                      src="../../assets/zlxcimgs/home_image_jinriprixun@2x.png"
                    >
                    <p class="li-num">{{censusListDate.trainTodayCount}}<span>人</span></p>
                  </div>
                  <p class="li-name">今日培训</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="home-layout">
        <div class="home-link">
          <p class="title-main">行业动态</p>
          <router-link
            tag="div"
            class="title-link"
            to="/about"
          >
            <p class="link-text">查看更多</p>
            <img
              class="link-img"
              src="../../assets/zlxcimgs/home_icon_xiayige@2x.png"
            >
          </router-link>
        </div>
        <div class="home-module">
          <div class="module-center" v-if="dataSheetList.length > 0">
            <ul class="about-list">
              <li class="list-li" v-for="item in dataSheetList" :key="item.industryDynamicId" @click="tapJumpDetail(item.industryDynamicId)">
                <p class="li-info">{{item.title}}</p>
                <p class="li-time">{{item.createDate}}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="home-layout">
        <div class="home-title">
          <p class="title-main">学车流程</p>
        </div>
        <div class="home-module">
          <div class="module-center">
            <ul class="drive-list">
              <li class="list-li">
                <p class="li-info">
                  <img
                    class="info-img"
                    src="../../assets/zlxcimgs/home_icon_wfindadrivingschool@2x.png"
                  >
                  <img
                    class="dis-info-img"
                    src="../../assets/zlxcimgs/home_icon_findadrivingschool@2x.png"
                  >
                </p>
                <p class="li-name">找驾校</p>
              </li>
              <li class="list-li">
                <p class="li-info">
                  <img
                    class="info-img"
                    src="../../assets/zlxcimgs/home_icon_winspect@2x.png"
                  >
                  <img
                    class="dis-info-img"
                    src="../../assets/zlxcimgs/home_icon_xinspect@2x.png"
                  >
                </p>
                <p class="li-name">体检</p>
              </li>
              <li class="list-li">
                <p class="li-info">
                  <img
                    class="info-img"
                    src="../../assets/zlxcimgs/home_icon_wfacetoface@2x.png"
                  >
                  <img
                    class="dis-info-img"
                    src="../../assets/zlxcimgs/home_icon_facetoface@2x.png"
                  >
                </p>
                <p class="li-name">面签</p>
              </li>
              <li class="list-li">
                <p class="li-info">
                  <img
                    class="info-img"
                    src="../../assets/zlxcimgs/home_icon_wsignup@2x.png"
                  >
                  <img
                    class="dis-info-img"
                    src="../../assets/zlxcimgs/home_icon_signup@2x.png"
                  >
                </p>
                <p class="li-name">报名缴费</p>
              </li>
              <li class="list-li">
                <p class="li-info">
                  <img
                    class="info-img"
                    src="../../assets/zlxcimgs/home_icon_wscience@2x.png"
                  >
                  <img
                    class="dis-info-img"
                    src="../../assets/zlxcimgs/home_icon_science@2x.png"
                  >
                </p>
                <p class="li-name">理科</p>
              </li>
              <li class="list-li">
                <p class="li-info">
                  <img
                    class="info-img"
                    src="../../assets/zlxcimgs/home_icon_wtechnicaldepartment@2x.png"
                  >
                  <img
                    class="dis-info-img"
                    src="../../assets/zlxcimgs/home_icon_technicaldepartment@2x.png"
                  >
                </p>
                <p class="li-name">术科</p>
              </li>
              <li class="list-li">
                <p class="li-info">
                  <img
                    class="info-img"
                    src="../../assets/zlxcimgs/home_icon_wscience@2x.png"
                  >
                  <img
                    class="dis-info-img"
                    src="../../assets/zlxcimgs/home_icon_science@2x.png"
                  >
                </p>
                <p class="li-name">科目四</p>
              </li>
              <li class="list-li">
                <p class="li-info">
                  <img
                    class="info-img"
                    src="../../assets/zlxcimgs/home_icon_wIssuecertificates@2x.png"
                  >
                  <img
                    class="dis-info-img"
                    src="../../assets/zlxcimgs/home_icon_Issuecertificates@2x.png"
                  >
                </p>
                <p class="li-name">发证</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="home-layout">
        <div class="home-title">
          <p class="title-main">学员报名缴费全流程</p>
        </div>
        <div class="home-module" @click="tabJumpDownload">
          <img
            class="module-img"
            src="../../assets/zlxcimgs/home_image_liucheng@2x.png"
          >
        </div>
      </div>
      <div class="home-layout">
        <div class="home-link">
          <p class="title-main">体检网点</p>
        </div>
        <div class="home-module" v-if="hospitalListData.length > 0">
          <div class="home-adress">
            <div class="adress" v-for="item in hospitalListData" :key="item.hospitalId">
              <div class="adress-icon">
                <img
                  class="icon-img"
                  src="../../assets/zlxcimgs/home_icon_daweizhi@2x.png"
                >
              </div>
              <div class="adress-ins">
                <div class="ins-title">{{item.hospitalName}}</div>
                <p class="ins-adress">
                  <img
                    class="icon-img"
                    src="../../assets/zlxcimgs/home_icon_location@2x.png"
                  >
                  <span>{{item.address}}</span>
                </p>
                <div class="ins-orther">
                  <div class="date">
                    <img
                      class="icon-img"
                      src="../../assets/zlxcimgs/home_icon_time@2x.png"
                    >
                    <span>{{item.time}}</span>
                  </div>
                  <div class="phone">
                    <img
                      class="icon-img"
                      src="../../assets/zlxcimgs/home_icon_tell@2x.png"
                    >
                    <span>{{item.phone}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryIndexCollectList, queryGetHospitalList, queryIndexSchoolGroupList, querySimpleIndustryDynamics, queryHomeEvaluate } from '@/api/herbalMedicine'
import { formatTime } from '@/utils/common.js'

export default {
  name: 'Home',
  created () {
    // 首页驾培统计
    this.queryIndexCollectList()
    this.censusListRequest = setInterval(() => {
      // 首页驾培统计
      this.queryIndexCollectList()
    }, 300000);
    // 查询体检地址列表
    this.geyQueryGetHospitalList()
    // 查询驾校数量
    this.geyQueryIndexSchoolGroupList()
    // 行业动态列表
    this.getQuerySimpleIndustryDynamics()
    // 首页评价相关
    this.getQueryHomeEvaluate()
    
    this.censusListRequest = setInterval(() => {
      // 首页评价相关
      this.getQueryHomeEvaluate()
    }, 300000);
  },
  beforeDestroy () {
    clearInterval(this.censusListRequest);
    this.censusListRequest = null
  },
  data () {
    return {
      // 首页评价相关
      homeEvaluate: null,
      // 地图散点数据
      sanData: null,
      // 驾培统计
      censusListDate: null,
      // 行业动态
      dataSheetList: [],
      bannerList: [
        {
          to: '/',
          img: require('@/assets/zlxcimgs/home_image_banner@2x.png'),
          mobileImg: require('@/assets/zlxcimgs/home_image_banner@2x.png'),
          info: ''
        },
        // {
        //   to: '/',
        //   img: require('@/assets/zlxcimgs/home_image_bannertwo@2x.png'),
        //   mobileImg: require('@/assets/zlxcimgs/home_image_bannertwo@2x.png'),
        //   info: ''
        // }
      ],
      score: 4.5,
      hospitalListData: []
    }
  },
  methods: {
    // 首页驾培统计
    queryIndexCollectList () {
      queryIndexCollectList({}).then(res => {
        this.censusListDate = res.data
      })
    },
    // 首页评价相关
    getQueryHomeEvaluate () {
      queryHomeEvaluate({}).then(res => {
        this.homeEvaluate = res.data
      })
    },
    // 查询驾校数量
    geyQueryIndexSchoolGroupList () {
      queryIndexSchoolGroupList({}).then(res => {
        let _sanData = [
          { name: "富阳区", LngAndLat: [119.75, 30.030339], num: 0 },
          { name: "拱墅区", LngAndLat: [120.14, 30.293843], num: 0 },
          { name: "滨江区", LngAndLat: [120.21, 30.204415], num: 0 },
          { name: "淳安县", LngAndLat: [119.0, 29.576045], num: 0 },
          { name: "建德市", LngAndLat: [119.45, 29.559729], num: 0 },
          { name: "临安区", LngAndLat: [119.37, 30.183843], num: 0 },
          { name: "上城区", LngAndLat: [120.3, 30.288198], num: 0 },
          { name: "桐庐县", LngAndLat: [119.42, 29.899843], num: 0 },
          { name: "西湖区", LngAndLat: [120.06, 30.193843], num: 0 },
          { name: "萧山区", LngAndLat: [120.44, 30.193843], num: 0 },
          { name: "余杭区", LngAndLat: [119.91, 30.323843], num: 0 },
          { name: "临平区", LngAndLat: [120.29, 30.419025], num: 0 },
          { name: "钱塘区", LngAndLat: [120.49, 30.322904], num: 0 },
        ]
        res.data.map(item => {
          _sanData.forEach(ele => {
            if (ele.name === item.regionName) ele.num = item.count
          })
        })
        this.sanData = _sanData
      })
    },
    // 行业动态列表
    getQuerySimpleIndustryDynamics () {
      querySimpleIndustryDynamics({
        isPublish: 1,
        pageIndex: 1,
        pageSize: 3,
        type: 1
      }).then(res => {
        if (res.data.list.length > 0) {
          res.data.list.forEach(ele => {
            ele.createDate = formatTime(ele.createDate)
          })
          this.dataSheetList = res.data.list
        }
      })
    },
    // 查询体检地址列表
    geyQueryGetHospitalList () {
      queryGetHospitalList({
        pageIndex: 1,
        pageSize: 2
      }).then(res => {
        this.hospitalListData = res.data
      })
    },
    // 跳转详情页
    tapJumpDetail (id) {
      this.$router.push({
        name:'Details',
        query: {
          id,
          type: 'about'
        }
      })
    },
    tabJumpDownload () {
      this.$router.push({
        name:'DownloadPage',
        query: {}
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
